import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
// @ts-ignore
import { Document, Page, pdfjs } from 'react-pdf'
import useMediaQuery from '@material-ui/core/useMediaQuery'
// Get the pdf.js worker from cloudflare content delivery network.
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.1.266/pdf.worker.js`
// import * as R from 'ramda'
// import { useEffect } from 'react'
/* eslint-disable @typescript-eslint/no-unused-vars */
// import { useInView } from 'react-intersection-observer'

const PDFPage = ({ index, onPageChange }: any) => {
  // const theme = useTheme()
  let scale = 1
  if (useMediaQuery((theme: any) => theme.breakpoints.down(675))) {
    scale = 0.8
  }
  if (useMediaQuery((theme: any) => theme.breakpoints.down(520))) {
    scale = 0.55
  }
  if (useMediaQuery((theme: any) => theme.breakpoints.down(355))) {
    scale = 0.35
  }
  // let scale = getScale;
  // const [ref, inView] = useInView({ threshold: 0.5 })

  // useEffect(() => {
  //   if (inView) onPageChange(index)
  // }, [inView])

  return (
    <Box
      boxShadow={3}
      bgcolor="background.paper"
      style={{ marginBottom: '1rem' }}
      onClick={() => onPageChange(index)}
      // className={classes.page}
    >
      {/* <div ref={ref}   data-pdfpage={index}> */}
      <Page wrap={true} pageIndex={index} scale={scale} />
      {/* </div> */}
    </Box>
  )
}

/**
 * `PDFViewer` component declaration.
  * @param {Object} file
  * @param {String} file.url
  * @param {String} file.data
  * @param {String} file.name
  * @param {String} file.mimeType
  * @param {Number} currentPage
  * @param {Number} totalPages
  * @param {Function} onPageChange
  * @param {Function} onLoadSuccess
  * @return PDFViewer
 */
const PDFViewer = ({ file, onLoadSuccess, onPageChange, currentPage }: any) => {
  return (
    <Document
      rotate={file.rotate}
      onLoadSuccess={onLoadSuccess}
      file={file.url || `data:${file.mimeType};base64,${file.data}`}
      options={{
        cMapPacked: true,
        cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
      }}
    >
      {/* {R.times(
        (index) => ( */}
          <PDFPage
            // key={index}
            index={currentPage}
            onPageChange={onPageChange}
            scale={file.scale}
          />
        {/* ), */}
      {/* //   totalPages
      // )} */}
    </Document>
  )
}

PDFViewer.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string,
    data: PropTypes.string,
    name: PropTypes.string,
    mimeType: PropTypes.string,
  }),
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  onLoadSuccess: PropTypes.func.isRequired,
}

export default PDFViewer